import { render, staticRenderFns } from "./HistoryManager.vue?vue&type=template&id=66229818&scoped=true&"
import script from "./HistoryManager.vue?vue&type=script&lang=js&"
export * from "./HistoryManager.vue?vue&type=script&lang=js&"
import style0 from "./HistoryManager.vue?vue&type=style&index=0&id=66229818&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66229818",
  null
  
)

export default component.exports